module.exports = __webpack_public_path__ + "css/Ascot.edc8a6e6.css";